<template>
  <div>

    <div class="search-product-toolbar">
      <SearchProductsToolbar @search="searchProducts"
                             @clear="onClear"
                             v-model="search"/>
    </div>

    <slot name="start"></slot>

    <div>
      <Loading type="line"
               :center="false"
               v-show="loading"/>

      <ScrollBar id="search-product"
                 :minHeight="350"
                 :maxHeight="350"
                 :endScrollBar="endScrollBar">

        <table class="table table-responsive-xs">
          <thead>
          <tr>
            <th class="search-product-td-product">
              <span class="title-header"></span>
            </th>
            <th class="text-center"
                v-show="showPrice">
              <span class="title-header"></span>
            </th>
            <th v-if="onlyPatrimony">
              <span class="title-header"></span>
            </th>
            <th class="text-center"
                v-if="showQuantity">
              <span class="title-header"></span>
            </th>
            <th class="text-center">
                <span class="title-header"
                      v-show="showPrice"></span> <span class="title-header"
                                                       v-show="showReplacementValue"></span>
            </th>
            <th class="text-center"></th>
          </tr>
          </thead>

          <tbody v-for="product in content.data"
                 :key="product.id">

          <ProductItem :product="product"
                       :onlyPatrimony="onlyPatrimony"
                       :showPrice="showPrice"
                       :showQuantity="showQuantity"
                       :showReplacementValue="showReplacementValue"
                       :canUpdate="canUpdate"
                       :showAddProduct="showAddProduct"
                       :showAvailability="showAvailability"
                       @add="add"/>
          </tbody>

          <tbody v-show="content.data == 0 && !loading">
          <tr>
            <td colspan="12">
              <span class="title">Nenhum registro encontrado!</span>
            </td>
          </tr>
          </tbody>

        </table>
      </ScrollBar>

      <div class="div-total-records">
        <span>Exibindo</span>
        <b>{{ content.data.length }}</b>
        <span>de</span>
        <b>{{ content.totalRecords }}</b>
        <span>registros</span>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import ScrollBar from "@nixweb/nixloc-ui/src/component/layout/ScrollBar.vue";
import TableTotalRecords from "@nixweb/nixloc-ui/src/component/shared/TableTotalRecords.vue";

import ProductItem from "./ProductItem.vue";
import SearchProductsToolbar from "../../rental/new-items-rent/SearchProductsToolbar.vue";

import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "SearchProduct",
  components: {
    ScrollBar,
    TableTotalRecords,
    Loading,
    ProductItem,
    SearchProductsToolbar,
  },
  props: {
    types: String,
    status: Number,
    statusPatrimony: Number,
    onlyPatrimony: Boolean,
    periodRent: Object,
    showPrice: Boolean,
    overlay: Boolean,
    showQuantity: {type: Boolean, default: true},
    showReplacementValue: {type: Boolean, default: false},
    canUpdate: {type: Boolean, default: true},
    showAddProduct: {type: Boolean, default: true},
    showAvailability: Boolean,
    addProduct: Function,
  },
  data() {
    return {
      content: {data: [], totalRecords: 0},
      baseParams: {
        search: undefined,
        filter: "contains",
        currentPage: 1,
        totalPerPage: 20,
      },
      urlGetAllByProduct:
          "/api/v1/stock/search-product/get-all-by-product-or-patrimony",
      loading: false,
      search: {query: "", category: {id: ""}, manufacturer: {id: ""}},
    };
  },
  created() {
    this.getAll();
  },
  computed: {
    ...mapState("generic", ["search", "executedSearch", "clearedSearch"]), // não remover
    ...mapGetters("user", ["hasPermission"]),
    moduleCurrent() {
      return this.$route.matched[0].props.default.module;
    },
  },
  methods: {
    ...mapActions("generic", ["getApi"]),
    ...mapMutations("generic", ["removeLoading"]),
    searchProducts() {
      this.resetSearchState();
      this.getAll();
    },
    getAll() {
      this.loading = true;
      let periodRent = this.createPeriodRent(this.periodRent);
      this.baseParams.search = this.search.query;

      let propsParam = {
        categoryProductId: this.search.category.id,
        manufacturerId: this.search.manufacturer.id,
        types: this.types,
        status: this.status,
        statusPatrimony: this.statusPatrimony,
        onlyPatrimony: this.onlyPatrimony,
        showPrice: this.showPrice,
        showAvailability: this.showAvailability,
      };

      if (this.baseParams.currentPage == 1) {
        this.content.data = [];
        this.loading = true;
      }

      let obj = {...this.baseParams, ...propsParam, ...periodRent};
      let params = {url: this.urlGetAllByProduct, obj};

      this.getApi(params).then((response) => {
        let self = this;
        response.content.data.map(function (value) {
          self.content.data.push(value);
        });
        this.content.totalRecords = response.content.totalRecords;
        setTimeout(function () {
          self.removeLoading(["btnSearch", "btnClean"]);
          self.loading = false;
        }, 350);
      });
    },
    onClear() {
      this.resetSearchState();
      this.getAll();
    },
    endScrollBar() {
      if (this.content.data.length != this.content.totalRecords) {
        this.baseParams.currentPage++;
        this.getAll();
      }
    },
    cleanParams() {
      this.baseParams.currentPage = 1;
    },
    resetSearchState() {
      this.cleanParams();
      this.content.data = [];
      this.content.totalRecords = 0;
    },
    add(product) {
      this.addProduct(product);
    },
    createPeriodRent(periodRent) {
      if (!periodRent) return {};
      return {
        deliveryDateHour: periodRent.deliveryDateHour,
        startDateHour: periodRent.startDateHour,
        endDateHour: periodRent.endDateHour,
        devolutionDateHour: periodRent.devolutionDateHour,
        minute: periodRent.minute,
        hour: periodRent.hour,
        day: periodRent.day,
        month: periodRent.month,
        year: periodRent.year,
      };
    },
  },
};
</script>

<style scoped>
.table th,
.table td {
  height: 10px !important;
  padding-left: 5px !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  padding-right: 5px !important;
  border-bottom: 0px !important;
  border: 0px !important;
}

.table tr {
  margin: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  border-bottom: 1px solid #f3f4f6 !important;
}

.title-header {
  font-size: 14px;
  color: #757d8c;
  font-weight: 400;
  text-transform: uppercase;
  margin-left: 3px;
}

.search-product-td-product {
  width: 400px;
}

.div-total-records {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  border-top: 1px solid #e6e7eb;
  padding: 6px 12px;
  font-size: 12px;
  color: #6b7280;
  background: transparent;
  border-radius: 0 0 8px 8px;
}

.div-total-records b {
  color: #374151;
}

.search-product-toolbar {
  margin-top: -20px;
}
</style>
